import React from 'react';
import { lazy } from 'react';
import { AuthGuard, DashboardLayout } from '@nsd/fe';
import { Trello as ClaimsIcon } from 'react-feather';
import appIcon from './images/appIcon.png';
import TopBarAddOn from 'src/components/TopBarAddOn';


const MODULE = {
  SALES: 'sales-686fc727-e5b4-4848-83d9-33e17777616f',
  REPORTS: 'reporting-161fac57-d6a6-4628-8845-a048edf0d0f8',
  COMMISSION_TIER: 'commissionSetup-f65f7b8b-943b-45fa-ae7c-a7ce2474fc2a',

  COMMISSION_VOUCHER_VIEW: 'commissionVoucher-30fac5fa-152e-4685-bde1-6b5145b2f81d',
  MONTHLY_TERRITORY_VIEW: 'monthlyTerritoryReview-0622055a-cbb8-459a-8586-aa271d2b01d0',

  COMMISSION_VOUCHER_MANAGER_VIEW: 'commissionVoucher-8b96f835-2bbd-4f69-b0d5-cdf079d65535',
  MONTHLY_TERRITORY_MANAGER_VIEW: 'managerMonthlyTerritoryReview-2f080b03-36c2-4469-a8f4-4c615d887a59',

  CRO_COMMISSION_VOUCHER_MANAGER_VIEW: 'cROManagerCommissionVoucher-29527f65-149a-4f9e-bd56-9781a2a2716d',
  CRO_MONTHLY_TERRITORY_MANAGER_VIEW: 'cROManagerMonthlyTerritoryReview-30adda08-3be1-4288-b976-4698a593bf19',

  CHANNEL_LEADER_MONTHLY_TERRITORY_VIEW: 'channelLeaderMonthlyTerritoryReview-71acd4f0-c70c-4647-bc25-3eccf6096643',

};

const appConfig = {
  appId: 'insightQore-5ddc80c4-2772-4f82-a8dc-56a227bc1c97',
  appName: 'Sales',
  priority: 1,
  path: 'sales',
  icon: appIcon,
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: '',
      view: lazy(() => import('src/views/sales/splash-view'))
    },
    {
      exact: true,
      path: 'monthly-territory-review',
      view: lazy(() => import('src/views/sales/monthly-territory-review'))
    },
    {
      exact: true,
      path: 'commission-voucher',
      view: lazy(() => import('src/views/sales/commission-voucher'))
    },
    {
      exact: true,
      path: 'monthly-territory-review-managerview',
      view: lazy(() => import('src/views/manager/monthly-territory-review'))
    },
    {
      exact: true,
      path: 'commission-voucher-managerview',
      view: lazy(() => import('src/views/manager/commission-voucher'))
    },
    {
      exact: true,
      path: 'cro-monthly-territory-review-managerview',
      view: lazy(() => import('src/views/cro/monthly-territory-review'))
    },
    {
      exact: true,
      path: 'cro-commission-voucher-managerview',
      view: lazy(() => import('src/views/cro/commission-voucher'))
    },
    {
      exact: true,
      path: 'channel-leader-monthly-territory-review',
      view: lazy(() => import('src/views/leader/channel-leader-monthly-territory-review'))
    },
    {
      exact: true,
      path: 'commission-setup',
      view: lazy(() => import('src/views/commission-setup'))
    },
    {
      exact: true,
      path: 'commission-setup-v2',
      view: lazy(() => import('src/views/commission-setup-v2'))
    },
  ],

  topBarConfig: {
    dataContextOptions: {
      enableDataContextOverride: true,
      customJSX: <TopBarAddOn />
    },
    contacts: false,
    search: false,
    notifications: false,
    settings: false,
    onDataContextChange: args => {
      console.log(args);
    }
  },
  navConfig: {
    navBarItems: [
      {

        subheader: 'Sales',
        items: [

          {
            title: 'Commission Voucher',
            href: 'commission-voucher',
            icon: ClaimsIcon,
            module: MODULE.COMMISSION_VOUCHER_VIEW
          },

          {
            title: 'Monthly Territory Review',
            href: 'monthly-territory-review',
            icon: ClaimsIcon,
            module: MODULE.MONTHLY_TERRITORY_VIEW
          },





        ]
      },
      {

        subheader: 'Monthly Territory Review',
        items: [



          // {
          //   title: 'Commission Voucher',
          //   href: 'commission-voucher-managerview',
          //   icon: ClaimsIcon,
          //   module: MODULE.COMMISSION_VOUCHER_MANAGER_VIEW
          // },

          {
            title: 'Manager',
            href: 'monthly-territory-review-managerview',
            icon: ClaimsIcon,
            module: MODULE.MONTHLY_TERRITORY_MANAGER_VIEW
          },


          // {
          //   title: 'Commission Voucher',
          //   href: 'cro-commission-voucher-managerview',
          //   icon: ClaimsIcon,
          //   module: MODULE.CRO_COMMISSION_VOUCHER_MANAGER_VIEW
          // },
          // {
          //   title: 'Chief Revenue Officer',
          //   href: 'cro-monthly-territory-review-managerview',
          //   icon: ClaimsIcon,
          //   module: MODULE.CRO_MONTHLY_TERRITORY_MANAGER_VIEW
          // },

          {
            title: 'Channel Leader',
            href: 'channel-leader-monthly-territory-review',
            icon: ClaimsIcon,
            module: MODULE.CHANNEL_LEADER_MONTHLY_TERRITORY_VIEW
          }



        ]
      },
      {
        subheader: 'Sales Team Management',
        items: [
          // {
          //   title: 'Commission Setup',
          //   href: 'commission-setup',
          //   icon: ClaimsIcon,
          //   module: MODULE.COMMISSION_TIER
          // },
          {
            title: 'Commission Setup',
            href: 'commission-setup-v2',
            icon: ClaimsIcon,
            module: MODULE.COMMISSION_TIER
          }
        ]
      }

    ]
  }
};

export default appConfig;
